const PORTRAIT = 'portrait';
const LANDSCAPE = 'landscape';

const detectDeviceOrientation = () => {
  const matchMediaList = window.matchMedia(`(orientation: ${PORTRAIT})`);
  return matchMediaList.matches ? PORTRAIT : LANDSCAPE;
};

export default detectDeviceOrientation;
